<script>
import { Bar } from 'vue-chartjs'
import ChartDataLabels from 'chartjs-plugin-datalabels'

import logger from "@/util/logger";

const LOG_TAG = 'network_usage_graph';

export default {
  name: LOG_TAG,
  extends: Bar,
  props: {
    data: {
      type: Array,
      default: function () {
        //{text: '', value: '', type: 'help', 'account'}
        return [/*{text: '', value: ''}*/];
      }
    },
    plugins: [
      ChartDataLabels
    ]
  },
  data() {
    return {
      mChartData: {
        labels: [],
        datasets: [
          {
            label: 'Download',
            data: [],
            backgroundColor: 'dodgerblue',
            datalabels: {
              formatter: function (value, context) {
                if (value > 0) {
                  let ci = context.chart;
                  let metaDownload = ci.getDatasetMeta(0);
                  let metaUpload = ci.getDatasetMeta(1);
                  if (metaUpload.hidden && !metaDownload.hidden) {
                    return context.chart.data.datasets[0].downloadLabel[context.dataIndex];
                  }
                }
                return '';
              },
            },
            downloadLabel: [],
          },
          {
            label: 'Upload',
            data: [],
            backgroundColor: 'mediumseagreen',
            datalabels: {
              formatter: function (value, context) {
                if (value > 0) {
                  let ci = context.chart;
                  let metaDownload = ci.getDatasetMeta(0);
                  let metaUpload = ci.getDatasetMeta(1);
                  if (!metaDownload.hidden && !metaUpload.hidden) {
                    return context.chart.data.datasets[1].totalLabel[context.dataIndex];
                  } else if (metaDownload.hidden) {
                    return context.chart.data.datasets[1].uploadLabel[context.dataIndex];
                  }
                }
                return '';
              },
            },
            uploadLabel: [],
            totalLabel: [],
          },
        ]
      },
      mOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
        },
        tooltips: {
          enabled: false
        },
        scales: {
          xAxes: [{
            gridLines: {
              display:false
            },
            stacked: true,
            ticks: {
              fontSize: 8,
            },
          }],
          yAxes: [{
            stacked: true,
            ticks: {
              fontSize: 10,
            },
          }],
        },
        plugins: {
          // Change options for ALL labels of THIS CHART
          datalabels: {
            color: 'black',
            clamp: true,
            anchor :'end',
            align :'top',
            font: {
              size: 8,
            },
          }
        }
      }
    };
  },
  mounted () {
    const vm = this;
    logger.d(LOG_TAG, 'mounted', vm.data);
    if (vm.data) {
      vm.data.forEach((data) => {
        vm.mChartData.labels.push(data.dateLabel);
        vm.mChartData.datasets[0].data.push(data.valueDownloadMb);
        vm.mChartData.datasets[1].data.push(data.valueUploadMb);

        // embed total
        vm.mChartData.datasets[0].downloadLabel.push(data.valueDownloadLabel);
        vm.mChartData.datasets[1].uploadLabel.push(data.valueUploadLabel);
        vm.mChartData.datasets[1].totalLabel.push(data.valueTotalLabel);
      });
    }
    vm.renderChart(vm.mChartData, vm.mOptions)
  }
}
</script>

<style scoped>
</style>
